export var BackgroundCommand;
(function (BackgroundCommand) {
    BackgroundCommand["PING"] = "PING";
    // MK
    BackgroundCommand["GET_MK"] = "getMk";
    BackgroundCommand["SEND_BACK_MK"] = "sendBackMk";
    BackgroundCommand["SAVE_MK"] = "saveMk";
    // Import
    BackgroundCommand["IMPORT_ACCOUNTS"] = "importAccounts";
    BackgroundCommand["SEND_BACK_IMPORTED_ACCOUNTS"] = "sendBackimportedAccounts";
    BackgroundCommand["SEND_BACK_SETTINGS"] = "sendBackSettings";
    BackgroundCommand["IMPORT_SETTINGS_CALLBACK"] = "importSettingsCallback";
    //RPC
    BackgroundCommand["SAVE_RPC"] = "saveRPC";
    BackgroundCommand["SET_ACTIVE_RPC"] = "setActiveRpc";
    // Keychain Request
    BackgroundCommand["SEND_REQUEST"] = "sendRequest";
    BackgroundCommand["UNLOCK_FROM_DIALOG"] = "unlockFromDialog";
    BackgroundCommand["REGISTER_FROM_DIALOG"] = "registerFromDialog";
    BackgroundCommand["ACCEPT_TRANSACTION"] = "acceptTransaction";
    // User preferences
    BackgroundCommand["UPDATE_CLAIMS"] = "updateClaims";
    BackgroundCommand["UPDATE_AUTOLOCK"] = "updateAutoLock";
    BackgroundCommand["LOCK_APP"] = "lockApp";
    // Multisig
    BackgroundCommand["MULTISIG_ACCEPT_RESPONSE"] = "MULTISIG_ACCEPT_RESPONSE";
    BackgroundCommand["MULTISIG_ACK_ACCEPT_RESPONSE"] = "MULTISIG_ACK_ACCEPT_RESPONSE";
    BackgroundCommand["MULTISIG_SEND_DATA_TO_POPUP"] = "MULTISIG_SEND_DATA_TO_POPUP";
    BackgroundCommand["MULTISIG_TRANSACTION_BROADCASTED"] = "MULTISIG_TRANSACTION_BROADCASTED";
    BackgroundCommand["MULTISIG_UNLOCK_WALLET"] = "MULTISIG_UNLOCK_WALLET";
    BackgroundCommand["MULTISIG_REQUEST_SIGNATURES"] = "MULTISIG_REQUEST_SIGNATURES";
    BackgroundCommand["MULTISIG_REQUEST_SIGNATURES_RESPONSE"] = "MULTISIG_REQUEST_SIGNATURES_RESPONSE";
    BackgroundCommand["MULTISIG_REFRESH_CONNECTIONS"] = "MULTISIG_REFRESH_CONNECTIONS";
})(BackgroundCommand || (BackgroundCommand = {}));
